module.exports = __webpack_public_path__ + "img/about1.cafad705.png";